import { KeyValueModel } from "model";
import { EnumIdDest } from "model/enums/enum-id-dest";

export const IdDestMock: KeyValueModel[] = [
    new KeyValueModel(EnumIdDest.INTERNA, 'Operação Interna'),
    new KeyValueModel(EnumIdDest.INTERESTADUAL, 'Operação Interestadual'),
    new KeyValueModel(EnumIdDest.EXTERIOR, 'Operação com Exterior'),
]